import type { CSSProperties } from 'react';

interface SortableHeaderProps<K extends string> {
  label: string;
  sortKey: K;
  activeKey: K;
  direction: 'asc' | 'desc';
  onSort: (key: K) => void;
  styles: Record<string, CSSProperties>;
  headerStyle?: CSSProperties;
}

export function SortableHeader<K extends string>({
  label,
  sortKey,
  activeKey,
  direction,
  onSort,
  styles,
  headerStyle,
}: SortableHeaderProps<K>) {
  const isActive = activeKey === sortKey;
  const ariaSort: 'ascending' | 'descending' | 'none' = isActive
    ? direction === 'asc' ? 'ascending' : 'descending'
    : 'none';

  return (
    <th
      style={{ ...styles.headerCell, ...styles.headerCellSortable, ...headerStyle }}
      onClick={() => onSort(sortKey)}
      aria-sort={ariaSort}
      scope="col"
    >
      <span style={styles.headerCellLabel}>
        {label}
        <span
          aria-hidden="true"
          style={{
            ...styles.sortIndicator,
            ...(isActive ? {} : styles.sortIndicatorInactive),
          }}
        >
          {isActive ? (direction === 'asc' ? '▲' : '▼') : '▲▼'}
        </span>
      </span>
    </th>
  );
}
